export const toList = optionsByPath => {
  if (!optionsByPath) {
    return [];
  }

  return optionsByPath
    .filter(option => option !== null)
    .map(option => ({
      id: option.id,
      name: option.name,
      ...option.extra,
    }));
};
